module.exports = __webpack_public_path__ + "img/layer-single.da09b537.svg";